import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { RoleEnum } from '@core/models/role';
import { ArquivoService } from '@core/services/arquivo.service';
import { DialogService } from '@core/services/dialog.service';
import { EntidadeDocumentoService } from '@core/services/entidade.documento.service';
import { MessageService } from '@core/services/message.service';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { ColumnOrder } from '@core/table/order';
import { DocumentoFormComponent } from '@modules/documento/documento-form/documento-form.component';
import { DocumentoModalComponent } from '@modules/documento/documento-modal/documento-modal.component';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { VinculoSharedDataService } from '@modules/vinculo/vinculo-shared-data.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { addFormControls } from '@shared/util/util';
import FileSaver from 'file-saver';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { NzModalService, ModalOptions } from 'ng-zorro-antd/modal';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject } from 'rxjs';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { DocumentoVinculoFormComponent } from '../documento-vinculo-form/documento-vinculo-form.component';

@Component({
  selector: 'app-documento-vinculo-list',
  templateUrl: './documento-vinculo-list.component.html',
  styleUrls: ['./documento-vinculo-list.component.scss']
})
export class DocumentoVinculoListComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(DocumentoVinculoFormComponent) documentoVinculoFormComponent!: DocumentoVinculoFormComponent;

  @Input() documentoForm!: FormGroup;
  @Input() data: any;
  @Input() nomePagina!: NomePaginaEnum;

  @Input() entidade: any;
  @Input() movimentacaoSocietaria: any;
  @Input() vinculo: any;
  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  @Output() dadosDocumentoEmit = new EventEmitter<any>();

  contatoFilterForm!: FormGroup;
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  statusContato: any[] = [];
  empresas: any[] = [];
  statusdocumentos: any[] = [];

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposContato: any[] = [];
  documentosSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  nzpage = 0;
  total = 0;
  nzFilterOption = (): boolean => true;

  loading = false;
  documento: any;

  constructor(
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private messageService: MessageService,
    private dialogService: DialogService,
    private arquivoService: ArquivoService,
    private modalService: NzModalService,
    private entidadeDocumentoService: EntidadeDocumentoService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private appSignalDataService: AppSignalDataService,
    private vinculoSharedDataService: VinculoSharedDataService,
    private movimentacaoSocietariaService: MovimentacaoSocietariaService,
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }
  ngOnChanges(): void {
    const nomeObs = this.nomePagina + 'Documentos';
    if (this.data && this.data[nomeObs]) {
      const documentos = this.data[nomeObs];
      this.dataSet = documentos;
    }
  }

  ngAfterViewInit(): void {
    this.documentoVinculoFormComponent?.dadosDocumentoVinculoEmit.subscribe((res: any) => {
      if (res) {
        this.dataSet.push(res);
        this.enviarDocumentos(this.dataSet);
      }
    });

    this.entidadeSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    });

    this.vinculoSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    });
  }

  ngOnInit(): void {
    const nomeObs = this.nomePagina + 'Documentos';
    addFormControls(this.documentoForm, {
      [nomeObs]: [],
    });
  }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  sort(event: any) {
    const column = event.sort.find((x: any) => x.value);
    if (column) {
      const sortKey = column.key;
      const sortOrder = column.value === 'ascend' ? 1 : -1;

      this.dataSet = [...this.dataSet].sort((a, b) => {
        const valueA = this.getNestedValue(a, sortKey);
        const valueB = this.getNestedValue(b, sortKey);

        if (valueA < valueB) {
          return -1 * sortOrder;
        }
        if (valueA > valueB) {
          return 1 * sortOrder;
        }
        return 0;
      });
    } else {
      this.dataSet = [...this.dataSet];
    }
  }

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o ? o[k] : null), obj);
  }

  downloadDocumentos(id: number) {
    this.arquivoService.downloadArquivo(id).subscribe(
      (response: any) => {
        let fileName = response.headers.get('filename');
        FileSaver.saveAs(response.body, fileName);
      }
    );
  }

  deletarDocumentos(obj: any): void {
    this.dialogService.confirm(`Deseja realmente excluir este documento? <b>${obj.nomeDocumento}</b>?`, () => {
      if (obj.id) {
        // this.entidadeDocumentoService.deletarArquivo(obj.id).subscribe(() => {
        //   this.messageService.success(`Arquivo <b>${obj.nomeDocumento}</b>deletado com sucesso!!!`);
        //   this.dataSet = this.dataSet.filter((item: any) => item.id !== obj.id);
        //   this.enviarDocumentos(this.dataSet);
        // })
      }
      else {
        if (obj.arquivoId) {
          this.arquivoService.deletarArquivo(obj.arquivoId).subscribe(res => {
            this.messageService.success(`Arquivo <b>${obj.nomeDocumento}</b>deletado com sucesso!!!`);
            this.dataSet = this.dataSet.filter((item: any) => item.arquivoId !== obj.arquivoId);
            this.enviarDocumentos(this.dataSet);
          })
        }
      }
    })
  }

  showModal(obj?: any): void {
    const config: ModalOptions<DocumentoModalComponent> = {
      nzTitle: 'Upload de Documento',
      nzContent: DocumentoModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '50vw',
      nzClosable: false
    }
    const modalRef = this.modalService.create(config);

    // console.log(obj)
    modalRef.componentInstance!.item = obj;
    modalRef.componentInstance!.acao = obj ? RouteAction.Editar : RouteAction.Inserir;

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        this.dataSet.push(result);
        this.enviarDocumentos(this.dataSet);
      }
    });
  }

  enviarDocumentos(dataSet: any) {
    const nomeObs = this.nomePagina + 'Documentos';
    this.documentoForm.get(nomeObs)?.setValue(dataSet);

    // if (this.vinculo) {
    //   this.dadosDocumentoEmit.emit(dataSet);
    //   this.vinculoSharedDataService.setUpdateDadosContato(dataSet);
    // }
    // else {
    //   this.dadosDocumentoEmit.emit(dataSet);
    //   this.entidadeSharedDataService.setUpdateDadosContato(dataSet);
    // }
  }
}
